export const PURCHASE_METHOD: Record<number, string> = {
  1: 'En consignación',
  2: 'En propiedad',
};

export const PURCHASE_METHOD_CONST: Record<string, number> = {
  CONSIGNACION: 1,
  PROPIEDAD: 2,
};

export const PURCHASE_METHOD_OPTIONS = Object.keys(PURCHASE_METHOD);
